export const getMarginSeparator = (index: number) => ({
  marginTop: index > 0 ? '4px' : '0px',
});
